export default {
  form: {
    start: 'formStart',
    close: 'formClose',
    open: 'formOpen',
    completed: 'formCompleted',
    error: 'formError',
  },
  internalSearch: 'internalSearch',
  propertySearchbyID: 'propertySearchbyID',
  pageView: 'pageview',
  error: 'trackError',
  propertyView: 'propertyView',
  calculator: {
    start: 'calculatorStart',
    step1: 'applicationPhase2',
    step2: 'applicationPhase3',
    completed: 'calculatorCompleted',
    specify: 'calculatorRefine',
    feedback: 'feedBackForm',
  },
};
